import React from 'react';
import { Button } from 'reactstrap';
import PropsTypes from 'prop-types';
import Router, { useRouter } from 'next/router';
import classnames from 'classnames';
import styles from 'styles/Course.module.scss';

const ButtonHeader = (props) => {
  const { data, itemClass } = props;
  const { asPath } = useRouter();
  return (
    <div className="home__button--group">
      {data &&
        data.map((item, index) => (
          <Button.Ripple
            key={index}
            className={classnames(
              styles['button-header-navigate'],
              itemClass,
              asPath === item?.link
                ? styles['button-header-navigate--active']
                : '',
            )}
            permission={item.permission}
            color={`${
              item?.active ? 'primary' : 'flat-primary btn-flat-blue-3'
            }`}
            onClick={() => {
              if (item?.link) {
                Router.push(item?.link || '/');
              }
              if (item?.action) {
                item.action();
              }
            }}
          >
            {item.icon}
            <span
              className={classnames(
                'align-middle ml-25',
                asPath === item?.link ? 'bold font-normal-2' : '',
              )}
            >
              {item.text}
            </span>
          </Button.Ripple>
        ))}
    </div>
  );
};

ButtonHeader.prototype = {
  data: PropsTypes.array.isRequired,
  itemClass: PropsTypes.string,
};

export default ButtonHeader;
